import { evolve } from 'ramda';
import { parseStringDate } from 'common/dateFnsUtils';
import { ProfileOwnerExcerptDTO } from 'models/user';

export enum DeviceStatus {
  RegisteredByAdmin = 'REGISTERED_BY_ADMIN',
  RegisteredByHigo = 'REGISTERED_BY_HIGO',
  RegisteredByUser = 'REGISTERED_BY_USER',
  RegisteredByPartner = 'REGISTERED_BY_PARTNER',
  Suspended = 'SUSPENDED',
  Confirmed = 'CONFIRMED',
  NotUsed = 'NOT_USED',
  LogOn = 'LOG_ON',
  LogonByAdmin = 'LOGON_BY_ADMIN',
}

export enum DeviceModeType {
  FamilyMode = 'FAMILY_MODE',
  ProMode = 'PRO_MODE',
}

export const deviceModeTypeLabelMap = new Map<DeviceModeType, string>([
  [DeviceModeType.FamilyMode, 'mode.family'],
  [DeviceModeType.ProMode, 'mode.pro'],
]);

export const deviceModeTypeTagColorMap = new Map<DeviceModeType, string>([
  [DeviceModeType.FamilyMode, 'green'],
  [DeviceModeType.ProMode, 'cyan'],
]);

export const deviceStatusLabelMap = new Map<DeviceStatus, string>([
  [DeviceStatus.RegisteredByAdmin, 'devices.status.registeredByAdmin'],
  [DeviceStatus.RegisteredByHigo, 'devices.status.registeredByHigo'],
  [DeviceStatus.RegisteredByUser, 'devices.status.registeredByUser'],
  [DeviceStatus.RegisteredByPartner, 'devices.status.RegisteredByPartner'],
  [DeviceStatus.Suspended, 'devices.status.suspended'],
  [DeviceStatus.Confirmed, 'devices.status.confirmed'],
  [DeviceStatus.NotUsed, 'devices.status.notUsed'],
  [DeviceStatus.LogOn, 'devices.status.logOn'],
  [DeviceStatus.LogonByAdmin, 'devices.status.logonByAdmin'],
]);

export interface BaseDeviceDTO {
  id: number;
  modeType: DeviceModeType;
  serialNumber: string;
}

export interface HigoDeviceDto {
  id: number;
  createDate: string;
  serialNumber: string;
  partnerId: number;
  hasToken?: boolean;
}

export interface HigoDevice {
  id: number;
  createDate: Date;
  serialNumber: string;
  partnerId: number;
}

//todo: discuss whether other props should be provided !
export type CreateHigoDeviceDTO = Pick<HigoDevice, 'serialNumber'>;

export const mapToHigoDevice = (dto: HigoDeviceDto): HigoDevice =>
  evolve(
    {
      createDate: parseStringDate,
    },
    dto
  );

export interface PartnerHigoDeviceDTO {
  assignedUser?: ProfileOwnerExcerptDTO;
  createDate: string;
  id: number;
  partnerId: number;
  serialNumber: string;
  status: DeviceStatus;
  hasToken?: boolean;
  modeType?: 'FAMILY_MODE' | 'PRO_MODE';
}

export interface PartnerDetailsDTO {
  id: number;
  name: string;
  parentPartner: PartnerDetailsDTO;
}

export interface PartnerHigoDevice
  extends Omit<PartnerHigoDeviceDTO, 'createDate'> {
  partnerDetails?: PartnerDetailsDTO;
  createDate: Date;
}

export interface HigoDeviceTokenDTO {
  deviceToken: string;
}

export const mapToPartnerHigoDevice = (
  dto: PartnerHigoDeviceDTO
): PartnerHigoDevice =>
  evolve(
    {
      createDate: parseStringDate,
    },
    dto
  );

export type PartnerHigoDeviceExcerpt = Pick<
  PartnerHigoDevice,
  'id' | 'serialNumber'
>;
